import { useTranslation } from "react-i18next";
import { Container } from "react-bootstrap";

export const ComingSoon = () => {
  const { t } =  useTranslation();

  return (
    <Container className="text-center" style={{marginTop: "10rem"}}>
      <h1 className="mb-3">{t("content:resources_page.title")}</h1>
      <p className="mb-4">{t("content:resources_page.body")}</p>
    </Container>
  );
};
